/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const xx_chain_about = () => `The xx network is a future-proof layer-one blockchain that facilitates thousands of transactions per second and protects against cryptography-breaking quantum computing. The xx network’s blockchain enables digital sovereignty by putting the users in control of the messaging and payments infrastructure. The xx blockchain utilizes breakthroughs in stake-based consensus protocols to provide energy-efficient and quantum-secure transactions at a scale to meet the needs for global payments.`
